<template>
  <section class="contact">
    <div
      class="contact__centered"
      v-if="isSubmitted"
    >
      <section class="contact__centered__row">
        <contact-top
          :title="$t('contact.title')"
        />
      </section>
      <contact-confirmation
        :success="isSuccess"
      />
    </div>
    <div
      class="contact__centered"
      v-if="!isSubmitted"
    >
      <section class="contact__centered__row">
        <contact-top
          :title="$t('contact.title')"
          :copy="$t('contact.copy')"
        />
      </section>
      <component
        v-if="componentName"
        :is="componentName"
      />
      <contact-call-back />
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  components: {
    ContactTop: () => import(/* webpackChunkName: "contact"  */ `./ContactTop`),
    ContactSite: () => import(/* webpackChunkName: "contact"  */ `./ContactSite`),
    ContactParticulier: () => import(/* webpackChunkName: "contact"  */ `./ContactParticulier`),
    ContactProfessionel: () => import(/* webpackChunkName: "contact"  */ `./ContactProfessionel`),
    ContactConfirmation: () => import(/* webpackChunkName: "contact"  */ `./ContactConfirmation`),
    ContactCallBack: () => import(/* webpackChunkName: "contact"  */ `./ContactCallBack`),
  },
  data() {
    return {
      componentName: null,
      form: null,
    }
  },
  mounted() {
    this.setWichForm()
  },
  computed: {
    ...mapState({
      isSubmitted: (state) => state.contact.isSubmitted,
      isSuccess: (state) => state.contact.isSuccess,
      userInfo: (state) => state.user.details,
    }),
  },
  watch: {
    isSuccess: {
      handler() {
        this.geolid()
      },
      deep: true,
    },
  },

  methods: {
    setWichForm() {
      const getUrl = window.location.href
      if (getUrl.includes('contact/particulier')) {
        this.componentName = 'ContactParticulier'
        return
      }
      if (getUrl.includes('contact/professionnel')) {
        this.componentName = 'ContactProfessionel'
        return
      }
      this.componentName = 'ContactSite'
    },
    geolid() {
      if (!window.gt) {
        return
      }
      if (this.isSuccess) {
        /* eslint-disable */
        gt('sendLead', 'Demande de contact', {
          'first_name': this.userInfo ? this.userInfo?.first_name : 'null',
          'last_name': this.userInfo ? this.userInfo?.last_name:  'null',
          'address': this.userInfo ? this.userInfo?.address: 'null',
          'email': this.userInfo ? this.userInfo?.email: 'null',
          'phone': this.userInfo ? this.userInfo?.tel : 'null',
          'city': this.userInfo ? this.userInfo?.city : 'null',
          'zip_code': this.userInfo ? this.userInfo?.postal_code : 'null'
        })
      }
      /* eslint-enable */
    },
  },
}
</script>

<style lang="scss" scoped>

.contact {
  display: flex;
  flex: 1;
  justify-content: center;
  margin: 0 auto;
  padding: 0 15px;

  @include teq-breakpoint($wide) {
    padding: 0;
    padding: 0 30px;
  }

  &__centered {
    align-content: flex-start;
    display: flex;
    flex: 1;
    flex-direction: column;
    width: 100%;

    @include teq-breakpoint($wide) {
      max-width: calc(100% - 186px);
    }

    &__row {
      display: flex;
      flex: 1;
      margin-bottom: 15px;
    }
  }
}
</style>
